<div class="h-100 w-100" style="margin-bottom: -1.5rem; overflow: hidden;">

    <div *ngIf="srcImgZona.length == 0" class="h-100 w-100 d-flex align-items-center justify-content-center img-map-livelli-container" [ngStyle]="!getWindowWidth() && {'margin-bottom':'40px'}">
        <div style="width:100%; margin-top: 100px; margin-bottom: 100px; text-align:center;">
            <div class="loader">
                <div class="outer"></div>
                <div class="middle"></div>
                <div class="inner"></div>
            </div>
        </div>
    </div>

    <div *ngIf="srcImgZona" class="w-100 h-100 d-flex align-items-center justify-content-center img-map-livelli-container" [ngStyle]="!getWindowWidth() && {'margin-bottom':'40px'}">
       
        <!--<canvas #myCanvas width="291" height="333">
        </canvas>-->
        <!--<div style="position:absolute; top:0; right:0; width:200px; height:100px;" [innerHTML]="coloreDisplay"></div>-->
        
        <object #myObject id="svgObject" type="image/svg+xml" data="" style="min-height: 50px; min-width: 50px; width:100%; height: 100%;"></object>
            
        <!--<img *ngFor="let element of srcImgZona; let i = index;" (click)="chiamaAlert(element)" style="font-size: 50px" class="img-map-livelli" [src]="element" />-->
        
        <!--<div *ngFor="let element of srcImgZona; let i = index;"
            [ngClass]="{ 'pos-label-1': (i == 0), 'pos-label-2': (i == 1), 'pos-label-3': (i == 2), 'pos-label-4': (i == 3), 'pos-label-5': (i == 4), 'pos-label-6': (i == 5), 'pos-label-7': (i == 6), 'pos-label-8': (i == 7) }">
            
            <span style="font-size:10pt; color: #6b6b6b80;">{{ element.nome }}</span>
        
        </div>-->
    
    </div>


    <!--<div class="col-md-8">
        <div class="row">
            <div class="col-md-6" *ngFor="let element of modelList; let i = index;">
                <nb-card class="liAllertaElem" [ngStyle]="!(element.livello > 1) && {'cursor':'auto'}">
                    <div class="row" style="height:100%;">
                        <div (click)="openModal(element.zona,element.livello)" class="col-md-12">
                            <div class="colore_card_header" style="height:100%; width:15%; text-align:center; float:left;">
                                <span class="number-alert">{{ element.zona }}</span>
                            </div>
                            <div class="circleAndLabel" style="height:100%; width:85%; float:left;">
                                <div style="float:left;" [ngClass]="{ 'bg-green': element.livello == 1, 'bg-orange': element.livello == 2, 'bg-red-light': element.livello == 3, 'bg-red': element.livello == 4 }" class="circle-custom"></div>
                                <div [ngClass]="{ 'color-green': element.livello == 1, 'color-orange': element.livello == 2, 'color-red-light': element.livello == 3, 'color-red': element.livello == 4 }" class="label-circle">{{ element.livelloDesc }}</div>
                            </div>
                        </div>
                    </div>
                </nb-card>
            </div>
        </div>
    </div>-->

    
</div>
